const SHOPPING_LIST_INFO_BOX_COOKIE = 'shopping-list-info-box';
const ONE_MONTH_SECONDS = 60 * 60 * 24 * 30;

export function useShoppingListInfoBox() {
	const dismissedCookie = useCookie<number | string | null>(SHOPPING_LIST_INFO_BOX_COOKIE, {maxAge: ONE_MONTH_SECONDS});

	const isDismissed = computed(() => dismissedCookie.value === 1 || dismissedCookie.value === '1');

	function dismiss() {
		dismissedCookie.value = 1;
	}

	return {isDismissed, dismiss};
}
